import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js'; // Import required Chart.js components

import Leftnavigation from './Leftnavigation';
import './style/homepage.css';
import Header from '../repeat/Header';
import Footer from '../repeat/Footer';

// Register components
ChartJS.register(ArcElement, Tooltip, Legend);

const Adminhomepage = () => {
  const [username, setUsername] = useState(null); // Default state is null
  const [isLoading, setIsLoading] = useState(true); // Add loading state to handle delayed checks
  const [boysData, setBoysData] = useState(null);
  const [girlsData, setGirlsData] = useState(null);
  const [staff, setstaff] = useState(null);
  const [totalData, setTotalData] = useState(null);

  // Fetch username from sessionStorage
  useEffect(() => {
    const storedUsername = sessionStorage.getItem('username');
    setUsername(storedUsername);
    setIsLoading(false); // Mark loading as complete
  }, []);

  // Fetch chart data
  useEffect(() => {
    fetch("https://gptkpm.in/backend/admin/pie.php")
      .then((response) => response.json())
      .then((data) => {
        // Boys Pie Chart Data
        setBoysData({
          labels: ["Boys", "Remaining"],
          datasets: [
            {
              label: "Boys Distribution",
              data: [data.boys, data.total - data.boys],
              backgroundColor: ["#36A2EB", "#D3D3D3"],
            },
          ],
        });

        // Girls Pie Chart Data
        setGirlsData({
          labels: ["Girls", "Remaining"],
          datasets: [
            {
              label: "Girls Distribution",
              data: [data.girls, data.total - data.girls],
              backgroundColor: ["#FF6384", "#D3D3D3"],
            },
          ],
        });
        setstaff({
          labels: ["staff"],
          datasets: [
            {
              label: "Girls Distribution",
              data: [data.staff],
              backgroundColor: ["#FF6f3d"],
            },
          ],
        });
        // Total Pie Chart Data
        setTotalData({
          labels: ["Boys", "Girls"],
          datasets: [
            {
              label: "Total Distribution",
              data: [data.boys, data.girls],
              backgroundColor: ["#36A2EB", "#FF6384"],
            },
          ],
        });
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  // Show a loading indicator while checking the session
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // If session is not present, redirect to login page
  if (!username) {
    return <Navigate to="/Admin" />;
  }

  return (
    <div className="admin-container">
      <Header />
      <Leftnavigation />
      <div className="dashboard">
      <div className="card welcome-card" style={{ flexDirection: "column" }}>
          <h2>Welcome to the Dashboard</h2>
          <p>Hello, {username}! You are logged in.</p>
        </div>
        <div className="card">
          <h3>VISION</h3>
          <p>To emanate as a leading institution in education to develop engineering professionals who are technically competent, ethical, and environmentally friendly for the betterment of society.</p>
          <h3>MISSION</h3>
          <p>To develop competent engineering professionals through high-quality academic instructions and industry collaborations to face emerging challenges with credibility, integrity, ethics, and social concern.</p>
        </div>
        
        <div className="pie-container">
          <div className="pie">
            <h3>Total Boys</h3>
            {boysData && <Pie data={boysData} />}
          </div>
          <div className="pie">
            <h3>Total Girls</h3>
            {girlsData && <Pie data={girlsData} />}
          </div>
          <div className="pie">
            <h3>Total Students</h3>
            {totalData && <Pie data={totalData} />}
          </div>
          <div className="pie">
            <h3>Total staff</h3>
            {staff && <Pie data={staff} />}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Adminhomepage;
